<template>
  <div class="search-list">search-list</div>
</template>

<script>
export default {
	data() {
		return {}
	},
	methods: {},
	computed: {},
	components: {},
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/base/search-list/search-list.vue